import styled from 'styled-components';
import { ContainerV2 } from '../../../stories/atoms/containerV2/ContainerV2';
import { IconWithText } from '../../../stories/molecules';

export const StoresViewWrapper = styled(ContainerV2)<{
  isMobile: boolean;
  isTablet: boolean;
  isSmallDesktop: boolean;
}>`
  display: grid;
  overflow-y: auto;
  gap: ${({ theme: { spacing }, isMobile, isTablet }) =>
    isMobile ? spacing(3) : isTablet ? spacing(4) : spacing(5)};
  grid-template-columns: ${({ isMobile, isTablet, isSmallDesktop }) => {
    if (isMobile) return '1fr';
    if (isTablet) return 'repeat(2, 1fr)';
    if (isSmallDesktop) return 'repeat(3, 1fr)';
    return 'repeat(5, 1fr)';
  }};
`;

export const UnderlinedTypography = styled(IconWithText)`
  width: 100%;
  text-decoration: underline;
  text-decoration-color: ${({ theme: { palette, color } }) =>
    palette.mode === 'dark' ? color.white : color.primary};
  cursor: pointer;
  justify-content: end;
`;
